var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Iframe"},[_c('el-button',{staticClass:"fh",attrs:{"type":"primary"},on:{"click":_vm.fh}},[_vm._v("返回")]),_c('iframe',{ref:"prints",staticClass:"znr",attrs:{"src":_vm.src}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }